import { render, staticRenderFns } from "./RefsUser.vue?vue&type=template&id=19d1b4ef"
import script from "./RefsUser.vue?vue&type=script&lang=ts"
export * from "./RefsUser.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports